function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M8.51 12.51c0 .351-.235.498-.498.498-.27 0-.504-.147-.504-.498v-.463c-.815-.076-1.547-.34-2.016-.768-.357-.31-.556-.668-.556-1.013 0-.393.27-.621.627-.621.222 0 .386.064.685.363.527.568 1.107.832 1.805.832.931 0 1.453-.422 1.453-1.09 0-.516-.358-.82-1.225-1.025l-1.19-.276C5.757 8.15 5.06 7.395 5.06 6.258c0-1.301.966-2.21 2.484-2.35V3.44c0-.351.234-.492.498-.492.27 0 .504.147.504.492v.487c.732.094 1.383.363 1.816.773.329.322.522.68.522 1.008 0 .34-.252.568-.58.568-.27 0-.469-.1-.727-.369-.51-.568-.967-.79-1.623-.79-.808 0-1.324.433-1.324 1.03 0 .499.363.838 1.107 1.002l1.19.27c1.447.316 2.144 1.02 2.144 2.18 0 1.347-.984 2.273-2.56 2.443v.469z",
  fill: "#057CCC"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z",
  fill: "#057CCC"
})));